export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/7Zs6wRfvStd4tXCozjDdER/PAGINA_1.jpg',
    alt: 'Pagina di esempio Servono cinque elementi per un giacimento: il sistema petrolifero con roccia madre, migrazione, roccia serbatoio, roccia di copertura e trappola',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qyee7uNQZtq9AfEzP8r5Sf/PAGINA_2.jpg',
    alt: "Pagina di esempio L'industria si divide in tre grandi settori: la catena del valore upstream, midstream e downstream",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dz8733m3gP8jQocMS5eE9Q/PAGINA_3.jpg',
    alt: 'Pagina di esempio Un pozzo è costruito a strati, come un telescopio: casing, cementazione, tubing di produzione e testa pozzo',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/n2jf9NxZqKtcNM64h5cu3Y/PAGINA_4.jpg',
    alt: 'Pagina di esempio La raffineria separa il greggio per punti di ebollizione: la distillazione frazionata',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cdUKmNFhJg8bdaxbwWHYM6/PAGINA_5.jpg',
    alt: 'Pagina di esempio Un barile diventa molti prodotti: GPL, benzina, cherosene, gasolio, olio combustibile, lubrificanti, bitume e nafta',
  },
];
